export class GetUserList {
    static readonly type = '[Users] Get';
    constructor(public pageIdex: number, public filterResult: {}) {}
}